<<template>
    <div>
        <el-row class="headerTop">
            <el-col :span="3">
                <div class="title">
                    {{this.$store.state.title}}
                </div>
            </el-col>
            <el-col :span="3">
                <div class="title">
                    <el-radio-group v-model="receive">
                        <el-radio label="0">未提现</el-radio>
                        <el-radio label="1">已提现</el-radio>
                    </el-radio-group>
                </div>
            </el-col>
            <el-col :span="17">
                <div class="">
                    <el-input v-model="phone"  placeholder="输入手机号" :style="{width:'260px'}"></el-input>
                    <el-button type="primary" @click="handleajax">搜索</el-button>
                </div>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span='24'>
                <el-table
                    ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                >
                        <el-table-column
                            label="序号"
                            prop="serNum"
                            width="95"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="phone"
                            label="手机号"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="sharephone"
                            label="被分享用户手机号"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="amount"
                            label="红包金额"
                        >
                        </el-table-column>
                        <el-table-column
                            label="用户注册时间"
                            prop="createTime"
                        >
                        </el-table-column>
                        <el-table-column
                            label="用户拆红包时间"
                            prop="openTime"
                        >
                        </el-table-column>
                        <el-table-column
                            label="用户提现红包时间"
                            prop="receiveTime"
                        >
                        </el-table-column>
                        <el-table-column
                            label="是否已提现"
                            prop="isReceive"
                        >
                            <template slot-scope="scope">
                                <div v-if="scope.row.isReceive=='1'">是</div>
                                <div v-else>否</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="操作"
                            width="120"
                        >
                            <template slot-scope="scope">
                                <el-button @click.native.prevent="deleteRow(scope)" type="text" size="small">
                                已提现
                                </el-button>
                                <div></div>
                            </template>
                        </el-table-column>
                </el-table>
            </el-col>
            <el-col>
                <div class="block">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="currentPage"
                        :page-size="pagesize"
                        layout="prev, pager, next, jumper"
                        v-show="showPagination"
                        :total=total>
                    </el-pagination>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    data(){
        return{
            value:'',
            currentPage:1,
            modalVisible:false,
            changeVisible:false,
            tableData: [],
            showPagination:true,
            total:0,
            pagesize:10,
            id:'',
            phone:'',
            receive:'0'
        }
    },
    mounted(){
        this.handleajax()
    },
    methods:{
        handleajax(){
            this.ajax.post('/shangPiao/packetList',{bizContent: {currentPage: this.currentPage, pageSize:this.pagesize, phone:this.phone, receive:this.receive}})
                .then(
                    result=>{
                    if(result.data.status=='0000'){
                        let add = result.data.data.data;
                        add.map((it,index)=>{
                            it.serNum=index+1
                        })
                        this.tableData=add
                        this.total=result.data.data.total;
                    }else{
                        this.$message.error(result.message);
                    }
                    }
                )
        },
        deleteRow(val){
            this.ajax.post('/shangPiao/receivepacket',{bizContent: {id: val.row.id}})
                .then(
                    result=>{
                    if(result.data.status=='0000'){
                        this.handleajax()
                    }else{
                        this.$message.error(result.message);
                    }
                    }
                )
        },
        handleCurrentChange(val) {
            this.currentPage=val
            this.handleajax();
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
    }
}
</script>
<style  scoped>
.headerTop{
    margin-top: 10px;
    margin-bottom: 10px;
}
.title{
    color: #333333FF;
    font-size: 24px;
}
.block{
    margin-top: 20px;
    width: 100%;
    text-align: center;
}
.save{
    margin-left: 45%;
}
.el-form-item__content{
    text-align: center!important;
}
</style>


// WEBPACK FOOTER //
// src/page/bussinessticket/getred.vue